<ng-container *ngIf="isLoading; else pageContent">
	<div class="app-spinner">
		<mat-spinner></mat-spinner>
	</div>
</ng-container>

<ng-template #pageContent>
<div class="resource-container position-relative">
	<div class="d-flex pt-3 ms-1">
		<span class="create-account">Courses</span>
		<span class="count-badge ms-3 mt-1">{{courseResources.length}}</span>
	</div>

	<ng-container *ngIf="courseResources.length > 0; else noCourseFound">
  <div class="main-card mt-3 rounded-4">
    <div class="resource-grid">
      <div class="quiz-card" *ngFor="let course of courseResources">
        <div class="quiz-header">
          <div class="quiz-icon">
            <img src="assets/images/unknown_document.svg" alt="quiz-icon"/>
          </div>
          <h5 class="quiz-title">{{ course.course_title }}</h5>
        </div>
        <div class="quiz-details">
          <div class="quiz-info">
             <div class="units ms-5">
                <img src="assets/images/unit_logo.svg" class="me-2">{{ course.total_units_count }} Units
            </div> 
          </div>
        </div>
        <div class="divider"></div>
        <button class="view-btn" (click)="viewCourse(course)">
          <img src="assets/images/open_in_new.svg" alt="play-icon" class="quiz-icon2" />View course
		</button>
      </div>
    </div>
  </div>
  </ng-container>
  <ng-template #noCourseFound>
  <p class="text-center mt-4"> No Courses found</p>
  </ng-template>
</div>
</ng-template> 